var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtboard1Copy405(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 608.7 446.5",
    style: {
      enableBackground: "new 0 0 608.7 446.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9EFF2E;}\n\t.st1{fill:#7CE25A;}\n\t.st2{fill:#231F20;}\n\t.st3{fill:#BE1E2D;}\n\t.st4{fill:#FFDD15;}\n\t.st5{fill:#1B75BB;}\n\t.st6{fill:#009345;}\n\t.st7{fill:#9F1622;}\n\t.st8{fill:#13588E;}\n\t.st9{fill:#006838;}\n\t.st10{fill:#C4AA15;}\n\t.st11{fill:none;}\n\t.st12{fill:#E8D92A;}\n\t.st13{fill:#E12626;}\n\t.st14{fill:#44B449;}\n\t.st15{fill:#3777BC;}\n\t.st16{fill:#45B549;}\n\t.st17{fill:#3677BB;}\n\t.st18{fill:#E8D828;}\n\t.st19{fill:#215584;}\n\t.st20{fill:#21782E;}\n\t.st21{fill:#837F12;}\n\t.st22{fill:#10C685;}\n\t.st23{fill:none;stroke:#FCB01A;stroke-width:6;stroke-miterlimit:10;}\n\t.st24{fill:#A51C3D;}\n\t.st25{fill:#00904C;}\n\t.st26{fill:#702634;}\n\t.st27{fill:#FF1A3B;}\n\t.st28{fill:#FC83B2;}\n\t.st29{fill:#413470;}\n\t.st30{fill:#6C42E2;}\n\t.st31{fill:#B076F4;}\n\t.st32{fill:#0F4417;}\n\t.st33{fill:#BB3A07;}\n\t.st34{fill:#7F2602;}\n\t.st35{fill:#F95B1C;}\n\t.st36{fill:#FFA60D;}\n\t.st37{fill:url(#);}\n\t.st38{fill:url(#SVGID_1_);}\n\t.st39{fill:url(#SVGID_00000108285294369784818020000006739086620610129315_);}\n\t.st40{fill:url(#SVGID_00000052074243792601035830000002376094519396899481_);}\n\t.st41{fill:url(#SVGID_00000148635048561712639630000012867587967232219579_);}\n\t.st42{fill:url(#SVGID_00000053543007642944233220000005132676755638107523_);}\n\t.st43{fill:url(#SVGID_00000008867218015278027230000003827383058540269239_);}\n\t.st44{fill:url(#SVGID_00000102529223130661335000000000761361463966045374_);}\n\t.st45{fill:url(#SVGID_00000026138779787363072310000009437740718026358672_);}\n\t.st46{fill:url(#SVGID_00000037662885099704796950000002106944216910648192_);}\n\t.st47{fill:url(#SVGID_00000176737545160010002960000003931643204745883838_);}\n\t.st48{fill:url(#SVGID_00000021808050057592630020000004995486670875515278_);}\n\t.st49{fill:url(#SVGID_00000075142149546691470100000009984472467769372557_);}\n\t.st50{fill:url(#SVGID_00000160872862796069927730000016205875222265363596_);}\n\t.st51{fill:url(#SVGID_00000135651181286407748640000001914354321986852741_);}\n\t.st52{fill:url(#SVGID_00000101785091023530001880000006794359010285680318_);}\n\t.st53{fill:url(#SVGID_00000087404962009069745260000005382404874153056676_);}\n\t.st54{fill:url(#SVGID_00000072249789351902263950000007450729682871468470_);}\n\t.st55{fill:url(#SVGID_00000049216329997249452420000007601698196497159563_);}\n\t.st56{fill:url(#SVGID_00000139281367863286202420000011768322639882694808_);}\n\t.st57{fill:url(#SVGID_00000116918584320207823560000002405068987699846792_);}\n\t.st58{fill:url(#SVGID_00000171719649641048984660000001713678108243298177_);}\n\t.st59{fill:url(#SVGID_00000006694489024900609480000012813497441218265009_);}\n\t.st60{fill:url(#SVGID_00000078740802335620778900000011033456964916321414_);}\n\t.st61{fill:url(#SVGID_00000088132324652966267470000011582024680539854232_);}\n\t.st62{fill:url(#SVGID_00000078755232940677272970000014608414849981298099_);}\n\t.st63{fill:url(#SVGID_00000096774751745632873440000006183310890727054265_);}\n\t.st64{fill:url(#SVGID_00000044877274653077329890000007776382483845532599_);}\n\t.st65{fill:url(#SVGID_00000011730646640881124580000006006282276933774480_);}\n\t.st66{fill:url(#SVGID_00000005233997606399381900000011642621261357340289_);}\n\t.st67{fill:url(#SVGID_00000113313408860387583520000010025688315486332805_);}\n\t.st68{fill:url(#SVGID_00000123412031014702488770000003638027433392354736_);}\n\t.st69{fill:url(#SVGID_00000156554969648440354970000000754427037326931122_);}\n\t.st70{fill:url(#SVGID_00000082367669557163281090000013497681835912377251_);}\n\t.st71{fill:url(#SVGID_00000174562177864931302780000002026192474245489323_);}\n\t.st72{fill:url(#SVGID_00000028287464931158017230000012009468155757505452_);}\n\t.st73{fill:url(#SVGID_00000065055945864273255670000015346382600301777061_);}\n\t.st74{fill:url(#SVGID_00000137843339276850138320000011900964522451452306_);}\n\t.st75{fill:url(#SVGID_00000177468857790340276700000002341550470832296872_);}\n\t.st76{fill:url(#SVGID_00000031925224157931706470000007145605773600896670_);}\n\t.st77{fill:url(#SVGID_00000183939681109807188600000002047495999439004835_);}\n\t.st78{fill:url(#SVGID_00000176032535505088811520000013384989321067177617_);}\n\t.st79{fill:url(#SVGID_00000029752595974344726920000003852618041864695487_);}\n\t.st80{fill:url(#SVGID_00000075865160796801262570000010332648892893462407_);}\n\t.st81{fill:url(#SVGID_00000140729760064844341070000007433906476724101027_);}\n\t.st82{fill:url(#SVGID_00000049929578206401031210000013259562391523904411_);}\n\t.st83{fill:url(#SVGID_00000055697170645353865620000005388588438429076615_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 488.6,
    y: 134.8,
    className: "st4",
    width: 5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "608.7,134.8 608.7,197.4 421.1,197.4 421.1,134.8 426.7,134.8 426.7,135 447.8,135 447.8,134.8  457.6,134.8 457.6,135 478.7,135 478.7,134.8 488.6,134.8 488.6,135 509.7,135 509.7,134.8 519.5,134.8 519.5,135 540.6,135  540.6,134.8 551.5,134.8 551.5,135 572.6,135 572.6,134.8 582.3,134.8 582.3,135 603.4,135 603.4,134.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.5,
    y: 134.8,
    className: "st4",
    width: 21.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.3,
    y: 134.8,
    className: "st4",
    width: 21.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.2,
    y: 257.9,
    className: "st2",
    width: 0,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.7,
    y: 134.8,
    className: "st4",
    width: 21.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 134.8,
    className: "st4",
    width: 21.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "608.7,197.4 608.7,320.4 421.1,320.4 421.1,257.9 421.1,257.9 421.1,197.4 483.7,197.4 483.7,257.9  546.2,257.9 546.2,257.9 546.2,257.9 546.2,257.9 546.2,257.9 546.2,197.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.6,
    y: 134.8,
    className: "st4",
    width: 21.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.5,
    y: 134.8,
    className: "st4",
    width: 21.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.2,
    y: 257.9,
    className: "st2",
    width: 0,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 71.3,
    className: "st2",
    width: 62.5,
    height: 250.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 8.7,
    className: "st3",
    width: 62.5,
    height: 62.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "393.7,258.9 393.7,446.5 268.6,446.5 268.6,384 331.1,384 331.1,321.4 268.6,321.4 268.6,196.4  331.1,196.4 331.1,258.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.2,
    y: 133.8,
    className: "st6",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.1,
    y: 133.8,
    className: "st6",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "393.7,133.8 393.7,196.4 268.6,196.4 268.6,133.8 276.2,133.8 276.2,135 297.3,135 297.3,133.8  307.1,133.8 307.1,135 328.1,135 328.1,133.8 338.1,133.8 338.1,135 359.2,135 359.2,133.8 369,133.8 369,135 390.1,135  390.1,133.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.1,
    y: 133.8,
    className: "st6",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 133.8,
    className: "st6",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "231.2,258.9 231.2,321.4 106.1,321.4 106.1,196.4 168.6,196.4 168.6,227.6 168.6,227.6 168.6,258.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.6,
    y: 196.4,
    className: "st2",
    width: 62.5,
    height: 31.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.6,
    y: 196.4,
    className: "st2",
    width: 0,
    height: 31.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.1,
    y: 133.8,
    className: "st5",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 133.8,
    className: "st5",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "231.2,133.8 231.2,196.4 106.1,196.4 106.1,133.8 113.1,133.8 113.1,135 134.2,135 134.2,133.8  143.9,133.8 143.9,135 165,135 165,133.8 175,133.8 175,135 196.1,135 196.1,133.8 205.8,133.8 205.8,135 226.9,135 226.9,133.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 133.8,
    className: "st5",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.8,
    y: 133.8,
    className: "st5",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.6,
    y: 196.4,
    className: "st2",
    width: 0,
    height: 31.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.8,
    y: 1.8,
    className: "st3",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.6,
    y: 1.8,
    className: "st3",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.1,
    y: 127.4,
    className: "st5",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 127.4,
    className: "st5",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 123.6,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 154.5,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 127.4,
    className: "st5",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.8,
    y: 127.4,
    className: "st5",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 185.5,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 216.4,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.2,
    y: 127.4,
    className: "st6",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.1,
    y: 127.4,
    className: "st6",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 286.8,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 317.6,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.1,
    y: 127.4,
    className: "st6",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 127.4,
    className: "st6",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 348.7,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 379.5,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.7,
    y: 127.4,
    className: "st4",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.6,
    y: 127.4,
    className: "st4",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 437.3,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 468.1,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.6,
    y: 127.4,
    className: "st4",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.5,
    y: 127.4,
    className: "st4",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 499.2,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 530,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.5,
    y: 127.4,
    className: "st4",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.3,
    y: 127.4,
    className: "st4",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 562,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 592.9,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 16.3,
    cy: 1.8,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 47.2,
    cy: 1.8,
    rx: 10.5,
    ry: 1.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard1Copy405);
export default __webpack_public_path__ + "static/media/Artboard 1 copy 4-05.4824c0d5c6ff576ac9231717d0076520.svg";
export { ForwardRef as ReactComponent };